import { render, staticRenderFns } from "./ExpensesEntryCrewDetails.vue?vue&type=template&id=0f8e9012&scoped=true&"
import script from "./ExpensesEntryCrewDetails.vue?vue&type=script&lang=js&"
export * from "./ExpensesEntryCrewDetails.vue?vue&type=script&lang=js&"
import style0 from "./ExpensesEntryCrewDetails.vue?vue&type=style&index=0&id=0f8e9012&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8e9012",
  null
  
)

export default component.exports